import React, { FC, useRef, useState } from "react";
import { Typography } from "@mui/material";
import { SketchPicker } from "react-color";
import { useClickOutsideListener } from "../../../../../videos/hooks/useClickOutside";

interface Props {
  name: string;
  value: string;
  onValueChange: (val: string) => void;
}

export const SingleOption: FC<Props> = ({ name, value, onValueChange }) => {
  const colorPicker = useRef<any>(null);
  const [showColorPicker, setShowColorPicker] = useState(false);
  useClickOutsideListener(colorPicker, () => setShowColorPicker(false));

  return (
    <div className="flex gap-4 items-center">
      <Typography color="var(--text)">{name}:</Typography>
      <div className="relative flex items-center justify-center">
        <div
          className="w-[16px] h-[16px] rounded-sm cursor-pointer border border-black"
          style={{ backgroundColor: value ?? '#000' }}
          onClick={() => setShowColorPicker(true)}
        />
        {showColorPicker && (
          <div ref={colorPicker}>
            <SketchPicker
              color={value}
              onChange={(val: any) => onValueChange(val.hex)}
              className="absolute z-20 left-[40px] -top-[40px]"
            />
          </div>
        )}
      </div>
    </div>
  );
};
